import { useActionState, useEffect } from "react";
import IconButton from "../../../../components/icon-button";
import { TrashIcon } from "@heroicons/react/24/outline";
import { OccasionCollection } from "../../../../models";
import { deleteOccasionCollection } from "../actions";
import toast from "react-hot-toast";

export function DeleteOccasionCollectionButton({
  item,
  onChanged,
}: {
  item: OccasionCollection;
  onChanged: () => void;
}) {
  const deleteWithId = deleteOccasionCollection.bind(null, item.id!);
  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    if (!window.confirm("Are you sure you want to delete this item?")) {
      e.preventDefault();
    }
  }
  const [state, formAction, isPending] = useActionState(deleteWithId, { success: false });

  useEffect(() => {
    if (!state.success) return;

    toast.success("Occasion collection deleted successfully");
    onChanged();
  }, [state, onChanged]);

  return (
    <form action={formAction} onSubmit={handleSubmit}>
      <IconButton label="Delete" icon={TrashIcon} loading={isPending} />
    </form>
  );
}
